import { parseAsInteger, parseAsString, useQueryStates } from 'nuqs';

export const useGroupListSearchQueryStates = () => {
  const [searchQueryStates, setSearchQueryStates] = useQueryStates({
    fiscalYear: parseAsString,
    name: parseAsString,
    page: parseAsInteger.withDefault(1),
  });
  return { searchQueryStates, setSearchQueryStates };
};
